export const CACHE_KEY_LIST_CLIENTS_AREA = 'clients-area';
export const CACHE_KEY_CLIENTS_AREA = 'clients-area-one';
export const ROUTE_PATH_CLIENTS_AREA = '/clients/area';
export const TRANSLATION_PREFIX_CLIENTS_AREA = 'clientsArea';
export const ARE_DIALOG_NAME_SPACE = 'area-dialog';

